export function useDocument() {
    function disableScroll(value: boolean) {
        document.documentElement.classList.toggle('disable_scroll', value)
    }

    return {
        disableScroll,
    }
}
